<div class="formalize-content-wrapper visible" *ngIf="false">
    <div class="formalize-content left-col" style="flex:1">
        <ng-container *ngFor="let item of items; let i = index">
            <div *ngIf="item.text && item.text.trim().length > 0" class="bulk-item card mb-3 p-0">
                <div
                    class="bulk-item-header d-flex align-items-center justify-content-between p-2 border-bottom bg-light">
                    <div class="header-left d-flex flex-column" style="min-width:0">
                        <div *ngIf="(item.companyName || item.clientName || item.company || item.client)"
                            class="company-name mb-2">
                            <span class="badge badge-primary">{{ item.companyName || item.clientName || item.company ||
                                item.client }}</span>
                        </div>
                        <div class="d-flex align-items-center">
                            <div class="question-label font-weight-bold tex t-truncate">{{item.label}}</div>
                            <span *ngIf="item.type" class="badge badge-secondary ml-2">{{item.type}}</span>
                        </div>
                    </div>
                    <div class="header-right d-flex align-items-center">
                        <div class="badge badge-primary text-muted small mr-2" style="white-space:nowrap">{{item.generated
                            ? (item.variants?.length + ' variants') : 'Not generated'}}</div>
                    </div>
                </div>

                <div class="bulk-item-row d-flex p-3">
                    <div class="bulk-item-left" style="flex:1; min-width:250px; max-width:35%; padding-right:1rem;">
                        <label class="d-block font-bold mb-1">Original</label>
                        <div class="bulk-item-original card p-3"
                            style="min-height:100px; white-space:pre-wrap; overflow:auto;">
                            {{item.text}}
                        </div>
                    </div>

                    <div class="bulk-item-right" style="flex:2; min-width:250px;">
                        <label class="d-block font-bold mb-1">Variants</label>

                        <div *ngIf="item.generated" class="variants-grid-bottom d-flex flex-column">
                            <!-- If assistant returned exactly one recommended variant, show it as applied -->
                            <div *ngIf="item.variants && item.variants.length === 1" class="card variant-card-bottom m-2 p-2" style="cursor:default;">
                                <div class="d-flex justify-content-between align-items-start">
                                    <div class="variant-tone-bottom font-weight-semibold">{{item.variants[0].label || 'Recommended'}}</div>
                                    <div class="small text-muted">Tone</div>
                                </div>
                                <div class="variant-text-bottom py-2" style="max-height:5.5rem; overflow:hidden;">
                                    <p class="mb-0">{{item.variants[0].text}}</p>
                                </div>
                                <div class="text-right mt-2">
                                    <button class="btn btn-sm btn-success">
                                        <i class="fa fa-check mr-1"></i>
                                        Selected
                                    </button>
                                </div>
                            </div>

                            <!-- Backwards compatibility: if multiple variants exist, show the grid (unchanged) -->
                            <div *ngIf="item.variants && item.variants.length > 1" class="d-flex flex-wrap">
                                <div *ngFor="let variant of item.variants; let variantIndex = index"
                                    class="card variant-card-bottom m-2 p-2"
                                    style="width:calc(50% - 1rem); cursor:pointer;" (click)="selectVariant(item, variantIndex)"
                                    [title]="variant.text" [ngClass]="{'border-success': item.selectedVariantIndex === variantIndex}">
                                    <div class="d-flex justify-content-between align-items-start">
                                        <div class="variant-tone-bottom font-weight-semibold">{{variant.label}}</div>
                                        <div class="small text-muted">Tone</div>
                                    </div>
                                    <div class="variant-text-bottom py-2" style="max-height:5.5rem; overflow:hidden;">
                                        <p class="mb-0">{{variant.text}}</p>
                                    </div>
                                    <div class="text-right mt-2">
                                        <button class="btn btn-sm btn-outline-primary"
                                            [ngClass]="{'btn-success': item.selectedVariantIndex === variantIndex}">
                                            <i class="fa fa-check mr-1"></i>
                                            <span *ngIf="item.selectedVariantIndex === variantIndex">Selected</span>
                                            <span *ngIf="item.selectedVariantIndex !== variantIndex">Use</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="!item.generated" class="text-muted p-3 border rounded">
                            <div class="mb-1"><strong>No variants generated yet</strong></div>
                            <div class="small">Click <em>Enhance Text</em> to generate variants for all visible items,
                                then choose one per item.</div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>
<div class="formalize-widget" [ngClass]="{ 'expanded': isExpanded }">
    <div class="formalize-card" [ngClass]="{ 'expanded': isExpanded }">
        <div class="formalize-header text-white p-3" (click)="toggleExpand()"
            [ngClass]="{ 'expanded mb-2': isExpanded }">
            <div class="pull-left">
                <i class="fas fa-magic formalize-icon"></i>
                <span class="formalize-title ml-3">AI Assistant</span>
            </div>
            <div class="pull-right">
                <i class="fa fa-chevron-right formalize-icon-chevron"></i>
            </div>
        </div>

        <!-- AI Assistant panel placed at bottom of selected comments (matches FormalizeComment layout) -->
        <div class="assistant-panel-wrapper" [ngClass]="{ 'expanded': isExpanded }">
            <div class="assistant-panel p-3">
                <div class="tone-row d-flex align-items-center">
                    <label for="toneSelect" class="control-label mb-0 font-bold mr-2">Select Tone:</label>
                    <div class="tone-selector-wrapper-inline" style="flex:1; max-width:220px">
                        <select id="toneSelect" [(ngModel)]="tone" class="tone-select inline-select"
                            [disabled]="!canEnhance()">
                            <option value="Formal">Formal</option>
                            <option value="Professional">Professional</option>
                            <option value="Executive">Executive</option>
                            <option value="Conversational">Conversational</option>
                            <option value="Friendly">Friendly</option>
                            <option value="Casual">Casual</option>
                        </select>
                    </div>

                    <button class="formalize-button inline-button ml-3" (click)="formalizeAll()"
                        [disabled]="!canEnhance()">
                        <span *ngIf="!isGenerating" class="button-text"><i class="fa fa-magic"></i><span
                            class="button-label">Enhance Comments</span></span>
                        <span *ngIf="isGenerating" class="button-text loading"><i
                            class="fa fa-spinner fa-spin"></i><span class="button-label">Enhancing...</span></span>
                    </button>
                </div>
                <div *ngIf="generateSuccess" class="formalize-feedback success-feedback mt-2" style="width: fit-content;">
                    <i class="fa fa-check-circle"></i>
                    <p class="mb-0">{{generateSuccess}}</p>
                </div>

                <div *ngIf="generateError" class="formalize-feedback error-feedback mt-2" style="width: fit-content;">
                    <i class="fa fa-exclamation-circle"></i>
                    <p class="mb-0">{{generateError}}</p>
                </div>
            </div>
        </div>
    </div>
</div> 